
export default function Content(){
 
    return (
        <>
        <div className="w-100 min-vh-100 text-center">
             <div style={{marginTop:"270px"}} className="d-inline-block ">
              <p className="line__1 ms-5 fs-3">Hello! I'm</p>
              <p className="line__2 ms-5 ps-5 fs-1">  SELVAM S</p>
             </div> 
             <div data-aos="fade-up" data-aos-delay="1000">   
             <p className='text-white fs-5'>Full-Stack Web Developer. Crafting seamless digital experiences with expertise in React , Node Js , Express js and Mongo DB.</p>
             <div className=' d-flex justify-content-center'>
            <a style={{textDecoration:"none"}} href="https://drive.google.com/file/d/1NOrCWuMIlHvBm3AFGVMGXw900luyGcGv/view?usp=sharing" target="_blank" rel="noreferrer"> 
             <button className="button ms-5" type="button">
               <span className="button__text">Download CV</span>
               <span className="button__icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35" id="bdd05811-e15d-428c-bb53-8661459f9307" data-name="Layer 2" className="svg"><path d="M17.5,22.131a1.249,1.249,0,0,1-1.25-1.25V2.187a1.25,1.25,0,0,1,2.5,0V20.881A1.25,1.25,0,0,1,17.5,22.131Z"></path><path d="M17.5,22.693a3.189,3.189,0,0,1-2.262-.936L8.487,15.006a1.249,1.249,0,0,1,1.767-1.767l6.751,6.751a.7.7,0,0,0,.99,0l6.751-6.751a1.25,1.25,0,0,1,1.768,1.767l-6.752,6.751A3.191,3.191,0,0,1,17.5,22.693Z"></path><path d="M31.436,34.063H3.564A3.318,3.318,0,0,1,.25,30.749V22.011a1.25,1.25,0,0,1,2.5,0v8.738a.815.815,0,0,0,.814.814H31.436a.815.815,0,0,0,.814-.814V22.011a1.25,1.25,0,1,1,2.5,0v8.738A3.318,3.318,0,0,1,31.436,34.063Z"></path></svg></span>
            </button></a>
            </div>
            </div>  
         </div>
      
        </>
    );
}